;(function($) {


    // Scroll anchor
    $('.js-scroll').on('click', function (e) {
        e.preventDefault()

        var target = this.hash,
            $target = $(target),
            //headerHeight = $('header').outerHeight(),
            headerHeight = 60, // header gets thinner when scrolled down
            scrollOffset = $target.offset().top

        // fix for homepage (hidden target element on mobile)
        /*
        if (scrollOffset === 0 && target === '#scene__promo') {
            scrollOffset = $(window).outerHeight()
        }
        */

        $('html, body').stop().animate({
            'scrollTop': scrollOffset - headerHeight
        }, 1000)

        $(target).each(function () {
            //$('.js-mod').removeClass('is-active')     // what's is js-mod?
            $(this).addClass('is-open')
            $(this).find('.js-content').slideDown(300)
        })
    })


}(jQuery));
